import { EMAIL_REGEX, USERNAME_REGEX } from '../../../utils';

const validate = values => {
  const errors = {}
  if (!values.email) {
    errors.email = 'Required'
  } else if (!EMAIL_REGEX.test(values.email)) {
    errors.email = 'Invalid email address'
  }
  if (!values.username) {
    errors.username = 'Required'
  } else if(!USERNAME_REGEX.test(values.username)) {
    errors.username = 'usernames can only contain letters, numbers, underscores and hyphens.'
  } else if (values.username.length > 30) {
    errors.username = 'Must be 30 characters or less'
  }

  if (!values.password || !values.password_confirm) {
    errors.password = 'Required';
  } else if (values.password !== values.password_confirm) {
    errors.password = 'Password fields must match'
  }
  if (!values.terms) {
    errors.terms = 'Required';
  }
  return errors
}

export default validate
